/**
 * Static route placeholder for the Insights archive.
 */
const BlogSkeleton = () => {
  return (
    <div
      className="min-h-screen bg-[var(--x3-page)] text-[var(--x3-text)]"
      aria-label="Loading Insights"
      aria-busy="true"
    >
      <div className="bg-[#121417] py-20">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <div className="mx-auto mb-4 h-12 w-64 max-w-full rounded-md bg-white/20" />
            <div className="mx-auto h-6 w-96 max-w-full rounded-md bg-white/15" />
          </div>
          <div className="h-96 overflow-hidden rounded-md border border-white/15 bg-white/10" />
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="mb-8 h-8 w-48 rounded-md bg-[var(--x3-surface-subtle)]" />
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {[1, 2, 3, 4, 5, 6].map(item => (
            <div
              key={item}
              className="overflow-hidden rounded-md border border-[var(--x3-border)] bg-[var(--x3-surface)]"
            >
              <div className="h-48 bg-[var(--x3-surface-subtle)]" />
              <div className="space-y-3 p-6">
                <div className="h-4 w-20 rounded bg-[var(--x3-surface-subtle)]" />
                <div className="h-6 w-full rounded bg-[var(--x3-surface-subtle)]" />
                <div className="h-4 w-full rounded bg-[var(--x3-surface-subtle)]" />
                <div className="h-4 w-3/4 rounded bg-[var(--x3-surface-subtle)]" />
                <div className="flex justify-between">
                  <div className="h-4 w-24 rounded bg-[var(--x3-surface-subtle)]" />
                  <div className="h-4 w-20 rounded bg-[var(--x3-surface-subtle)]" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default BlogSkeleton
